import React from 'react'

import { useTheme } from '@emotion/react'
import { useTranslation } from 'react-i18next'

import { Center, Flex, PaddingInset, spacing, Stack, Text } from '@cash-design-system/react'
import { FormBlockerElementHeroElement } from '@cash-web/protos/squareup/franklin/form_blocker.pb'
import { useArcadeMigrationFeatureFlag } from '@cash-web/shared-data-access-arcade-migration'
import { useTextTokenizer } from '@cash-web/shared-feature-use-text-tokenizer'
import { Animation } from '@cash-web/shared-ui-lottie-animation'

export function HeroElement(props: FormBlockerElementHeroElement): React.ReactElement {
  const textTokenizer = useTextTokenizer()
  const theme = useTheme()
  const { t } = useTranslation()

  const isArcadeMigrationEnabled = useArcadeMigrationFeatureFlag('apps')

  const animationUrl =
    props.animation &&
    (theme.darkMode && props.animation.dark_url ? props.animation.dark_url : props.animation.light_url)

  const animationWidthPercentage = (props.animation_width_percentage ?? 1) * 100

  if (isArcadeMigrationEnabled)
    return (
      <Flex flexDirection="column" gap="m" alignItems="center" justifyContent="center">
        {animationUrl && (
          <Animation
            animationUrl={animationUrl}
            width={`${animationWidthPercentage}%`}
            alt={props.title || t('Hero animation', { context: 'Fallback alt text for hero animation' })}
          />
        )}
        {props.title && (
          <Text typography="hero" as="h1" textAlign="center" color="textStandard">
            {textTokenizer(props.title)}
          </Text>
        )}
        {props.subtitle && (
          <Text typography="bodyMedium" textAlign="center" color="textSubtle">
            {textTokenizer(props.subtitle)}
          </Text>
        )}
      </Flex>
    )
  return (
    <PaddingInset>
      <Stack space={spacing.m}>
        {animationUrl && (
          <Center>
            <Animation
              animationUrl={animationUrl}
              width={`${animationWidthPercentage}%`}
              alt={props.title || t('Hero animation', { context: 'Fallback alt text for hero animation' })}
            />
          </Center>
        )}
        {props.title && (
          <Center centerText={true}>
            <Text typography="hero" as="h1">
              {textTokenizer(props.title)}
            </Text>
          </Center>
        )}
        {props.subtitle && (
          <Center centerText={true}>
            <Text typography="body">{textTokenizer(props.subtitle)}</Text>
          </Center>
        )}
      </Stack>
    </PaddingInset>
  )
}
